import React, {cloneElement, useCallback} from 'react';
import {SaveButton, useRedirect, useCreate} from 'react-admin';
import {useUpdate} from 'ra-core';

export const OverrideRecord = ({children, overrideBasePath, overrideRecord, ...props}) => {
   return cloneElement(children, {basePath: overrideBasePath, record: overrideRecord, props});
};

export const WithProps = ({children, callBackFunc, ...props}) => {
   let {record} = props;
   let newRecord = callBackFunc ? callBackFunc(record) : record;
   props.record = newRecord;
   return children(props);
};

export const SaveWithUpdateButton = (props) => {
   const {replaceFunction, updatedSource} = props;
   const [update] = useUpdate(updatedSource, props.record.id);
   const redirectTo = useRedirect();
   // get values from the form

   const handleSave = useCallback(
      (values, redirect) => {
         update(
            {
               payload: {id: values.id, data: replaceFunction(values)}
            },
            {
               onSuccess: ({data: newRecord}) => {
                  redirectTo(redirect);
               }
            }
         );
      },
      [update, replaceFunction, redirectTo]
   );
   return <SaveButton {...props} onSave={handleSave}  undoable={false}/>;
};

export const SaveWithCreateButton = (props) => {
   const {replaceFunction, updatedSource} = props;
   const [create] = useCreate(updatedSource, props.record.id);
   const redirectTo = useRedirect();
   // get values from the form

   const handleSave = useCallback(
      (values, redirect) => {
         create(
            {
               payload: {id: values.id, data: replaceFunction(values)}
            },
            {
               onSuccess: ({data: newRecord}) => {
                  redirectTo(redirect);
               }
            }
         );
      },
      [create, replaceFunction, redirectTo]
   );
   return <SaveButton {...props} onSave={handleSave}  undoable={false}/>;
};